const firstLetterToLowerCase = (string?: string | null) => {
  return string ? string.charAt(0).toLowerCase() + string.slice(1) : undefined
}

export default firstLetterToLowerCase